<script lang="ts">
    import EmployeeWidget from "$lib/partials/EmployeeWidget.svelte";
    import EmployeeFormGroup from "$lib/partials/EmployeeFormGroup.svelte";
    import {onMount} from "svelte";
    import {getReference} from "$lib/calls/hr";
    import {Toggle} from "flowbite-svelte";

    export let editing = false;
    export let employee = {};

    let martialStatusOptions = [
        {name: 'ledig', value: 'single'},
        {name: 'verheiratet', value: 'married'},
        {name: 'geschieden', value: 'divorced'},
        {name: 'verwitwet', value: 'widow'},

    ]
    let religiousDenominationOptions = [];
    let taxBracketOptions = [];
    let healthInsuranceTypes = [
        {name: 'Privat', value: false},
        {name: 'Gesetzlich', value: true},
    ]
    let healthInsuranceOptions = [];

    onMount(async () => {
        if (!employee.healthInsurance) {
            employee.healthInsurance = {
                isPublic: true
            }
        }
        religiousDenominationOptions = (await getReference('Kirchensteuer')).map(x => ({name: x.value, value: x.key}));
        taxBracketOptions = (await getReference('Steuerklassen')).map(x => ({name: x.value, value: x.key}));
        healthInsuranceOptions = (await getReference('Krankenkassen')).map(x => ({name: x.value, value: x.key}));

    })
</script>

<EmployeeWidget headline="Lohnsteuer / Krankenversicherung (KV)" collapsible open={false}>

    <svelte:fragment slot="left">

        <EmployeeFormGroup
                {editing}
                label="Familienstand"
                labelFor="martialStatus"
                data={martialStatusOptions}
                value={employee.cv.familyStatus}
                extract={selected => employee.cv.familyStatus = selected.value}>
            {martialStatusOptions.find(option => option.value === employee.cv.familyStatus || '')?.name || '-'}
        </EmployeeFormGroup>

        <EmployeeFormGroup
                {editing}
                label="Konfession"
                labelFor="religiousDenomination"
                data={religiousDenominationOptions}
                value={employee.cv.religiousAffiliation}
                extract={selected => employee.cv.religiousAffiliation = selected.value}>
            {religiousDenominationOptions.find(option => parseInt(option.value) === employee.cv.religiousAffiliation || '')?.name || '-'}
        </EmployeeFormGroup>

        <EmployeeFormGroup
                {editing}
                label="SV-Nummer"
                bind:value={employee.cv.socialSecurityNumber}
                labelFor="socialSecurityNumber">
            {employee.cv.socialSecurityNumber || '-'}
        </EmployeeFormGroup>

        <EmployeeFormGroup
                {editing}
                label="Freie Steuerklasse"
                labelFor="taxationClass"
                data={taxBracketOptions}
                extract={selected => employee.cv.taxationClass = selected.value}>
            {taxBracketOptions.find(option => option.value === employee.cv.taxationClass || '')?.name || '-'}
        </EmployeeFormGroup>

        <EmployeeFormGroup
                {editing}
                label="Steuer ID"
                labelFor="taxId">
            {employee.taxId || '-'}
        </EmployeeFormGroup>

        <EmployeeFormGroup
                {editing}
                label="Kinderfreibetrag"
                labelFor="childAllowance">
            {employee.childAllowance || ''}
        </EmployeeFormGroup>

        <EmployeeFormGroup
                {editing}
                label="Nachweis RV-Freiheit"
                labelFor="childAllowance"
                type="checkbox">
            {employee.childAllowance || ''}
        </EmployeeFormGroup>

        <EmployeeFormGroup
                {editing}
                label="Nachweis der Elterneigenschaft"
                labelFor="childAllowance"
                type="checkbox">
            {employee.childAllowance || ''}
        </EmployeeFormGroup>

    </svelte:fragment>

    <svelte:fragment slot="right">

        {#if editing}
            <div class="mt-8 mb-5">
                <Toggle label="Privat / Gesetzlich" bind:checked={employee.healthInsurance.isPublic}>Gesetzlich versichert</Toggle>
            </div>

        {/if}


        <EmployeeFormGroup
                label="Art der KV"
                labelFor="typeOfHealthInsurance"
                data={healthInsuranceTypes}
                extract={selected => employee.healthInsurance.isPublic = selected.value}>
            {healthInsuranceTypes.find(option => option.value === employee.healthInsurance?.isPublic || '')?.name || '-'}
        </EmployeeFormGroup>

        {#if employee.healthInsurance.isPublic}


        <EmployeeFormGroup
                {editing}
                label="Name gesetzliche KV"
                labelFor="nameOfStatutoryHealthInsurance"
                data={healthInsuranceOptions}
                extract={selected => employee.healthInsurance.insuranceName = selected.value}>
            {healthInsuranceOptions.find(option => option.value === employee.healthInsurance?.insuranceName || '')?.name || '-'}
        </EmployeeFormGroup>

           <!-- <EmployeeFormGroup
                    {editing}
                    label="Bereich gesetzliche KV"
                    labelFor="areaOfStatutoryHealthInsurance">
                {employee.areaOfStatutoryHealthInsurance || ''}
            </EmployeeFormGroup>-->

            <EmployeeFormGroup
                    {editing}
                    label="Ort gesetzliche KV"
                    labelFor="placeOfStatutoryHealthInsurance">
                {employee.placeOfStatutoryHealthInsurance || ''}
            </EmployeeFormGroup>
        {:else}

            <EmployeeFormGroup
                    {editing}
                    label="Name private KV"
                    labelFor="nameOfPrivateHealthInsurance">
                {employee.nameOfPrivateHealthInsurance || ''}
            </EmployeeFormGroup>
        {/if}

    </svelte:fragment>

</EmployeeWidget>